<div class="mdv-image-gallery">
  <ca-image-loader
    *ngIf="fileId !== null; else placeholder"
    [image]="
    {id: fileId} | filedownloadurl | async
    "
    [showPlaceholder]="false"
    fit="contain"
  >
  </ca-image-loader>
  <ng-template #placeholder>
    <div class="media-placeholder"></div>
  </ng-template>
</div>
